import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const policies = [
  {
    key: "security",
    label: "Information Security Policy",
    path: "/information-security",
  },
  {
    key: "terms",
    label: "Terms and Conditions",
    path: "/terms-and-conditions",
  },
  {
    key: "privacy",
    label: "Privacy Policy",
    path: "/privacy-policy",
  },

];

const PolicyNav = ({ active }) => {
  const navigate = useNavigate();

  return (
    <div className="policy-nav-section">
      {policies.map((policy, index) => (
        <Button
          key={policy.key}
          className={
            active === policy.key
              ? "custom-antd-btn-selected"
              : "custom-antd-btn"
          }
          onClick={
            active === policy.key ? undefined : () => navigate(policy.path)
          }
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
          data-aos-delay={`${(index + 1) * 100}`}
        >
          {policy.label}
        </Button>
      ))}
    </div>
  );
};

export default PolicyNav;
